<app-payment-panel-stripe-generic
  type="STRIPE_GOOGLE_PAY"
  [isPayButtonVisible]="false"
></app-payment-panel-stripe-generic>
